import classNames from 'classnames';
import { HTMLAttributes } from 'react';
import styles from './styles.module.scss';

export interface IToggleProps extends HTMLAttributes<HTMLButtonElement> {
  checked: boolean;
  onClick: () => void;
  icon?: React.ReactNode;
  height?: number | string;
  width?: number | string;
}

const Toggle = ({
  checked,
  onClick,
  icon,
  height = '.875rem',
  width = '1.5rem',
  className,
  ...htmlProps
}: IToggleProps) => {
  return (
    <button
      style={{ height, width }}
      onMouseDown={(event) => event.preventDefault()}
      onClick={onClick}
      aria-checked={checked ? 'true' : 'false'}
      role='switch'
      className={classNames(styles.container, className, { [styles.checked]: checked })}
      {...htmlProps}
    >
      <div className={styles.toggle} />
      <div style={{ width: height }} className={styles.handle}>
        {icon}
      </div>
    </button>
  );
};

export default Toggle;
